import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {vec3} from 'gl-matrix';

const tempVec = vec3.create();
/**
 * hover
 */
export class Hover extends Component {
    static TypeName = 'hover';

    /* Properties that are configurable in the editor */

    @property.float(1.0)
    speed!: number;

    start() {
        this.object.getPositionLocal(this.startPos);
    }

    startPos = new Float32Array(3);
    time = 0;

    update(dt: number) {
        this.time += dt;

        tempVec[0] = this.startPos[0];
        tempVec[1] = this.startPos[1] + Math.abs(Math.sin(this.time * this.speed));
        tempVec[2] = this.startPos[2];
        this.object.setPositionLocal(tempVec);
    }
}
